import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Santafe from "../../images/home/noticias/hyundai-nuevo-santa-fe.webp";
import SantafeSmall from "../../images/home/noticias/hyundai-nuevo-santa-fe-small.webp";
import SantafeMedium from "../../images/home/noticias/hyundai-nuevo-santa-fe-medium.webp";
import Futuro from "../../images/home/noticias/hyundai-futuro.webp";
import FuturoSmall from "../../images/home/noticias/hyundai-futuro-small.webp";
import FuturoMedium from "../../images/home/noticias/hyundai-futuro-medium.webp";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { LazyLoadImage } from "react-lazy-load-image-component";
function NoticiasRecientes() {
  return (
    <section className="bg-blue mt-3 align-items-center text-center">
      <Container className="py-4 py-md-5">
        <Row>
          <Col md={12}>
            <h2 className="home-noticia-titulo">NOTICIAS</h2>
            <h3 className="home-noticia-subtitulo mt-2 mb-2 mb-md-3">
              Mira lo que está pasando.
            </h3>
          </Col>
        </Row>
        <Row>
          {/*<Col md={6} className=" mt-3 mt-md-2">
            <picture>
              <source
                srcSet={SantafeSmall}
                sizes="(max-width: 480px) 100vw"
                width={100}
                height={100} />
              <source srcSet={SantafeMedium}
                sizes="(max-width: 768px) 50vw"
                width={100}
                height={100} />
              <source srcSet={Santafe}
                sizes=" 33vw"
                width={100}
                height={100} />
              <LazyLoadImage src={Santafe} alt="Marca visión" className="w-100 responsive-image" effect="blur"/>
            </picture>
            <p className="noticia-tarjeta-subtitulo mt-2 mt-md-3">
              Hyundai Motor presentará el diseño del nuevo SUV de Santa Fe, el último vehículo familiar de aventura. Próximamente.
            </p>
          </Col>*/}
            <Col md={12} className=" mt-3 mt-md-2 text-center">
            <picture>
              <source
                srcSet={FuturoSmall}
                sizes="(max-width: 480px) 100vw"
                width={100}
                height={100}
              />
              <source
                srcSet={FuturoMedium}
                sizes="(max-width: 768px) 50vw"
                width={100}
                height={100}
              />
              <source
                srcSet={Futuro}
                sizes=" 33vw"
                width={100}
                height={100}
              />
              <LazyLoadImage src={Futuro} alt="Marca visión" className="w-100 responsive-image" effect="blur" />
            </picture>
            <p className="noticia-tarjeta-subtitulo mt-2 mt-md-3">
              ¡El futuro es ahora y estamos listos! El progreso comienza aquí.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
export default NoticiasRecientes;